import { Component, Input } from '@angular/core';
import { DictionaryRequestStatus } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';

@Component({
  selector: 'request-card-view',
  templateUrl: './request-card-view.component.html',
  styleUrls: ['./request-card-view.component.scss'],
  standalone: false,
})
export class RequestCardViewComponent {
  public constructor() {}

  public currentDate: Date;
  public dictionaryRequestStatus = DictionaryRequestStatus;

  @Input() public requests: app.models.RequestListModel[];
  @Input() public props: app.models.DynamicPropsDictionary;
  @Input() public viewDetails: any;
}
